import { Title, Breadcrumbs } from "../../components";
import api from "../../api";
import { useState, useEffect } from "react";
import styles from './style.module.css';
import Moment from 'react-moment';
import { FiCalendar } from 'react-icons/fi';

const Bulletins = () => {
    const [bulletins, setBulletins] = useState([])
    useEffect(() => {
        api.getBulletins()
            .then((data) => {
                setBulletins(data);
            })
            .catch((err) => {
                console.log(err.message);
            });
    }, []);
    return (
        <>
            <Title title='Информационный бюллетень "Белая ромашка"' />
            <Breadcrumbs urls={[{ title: 'Информационный бюллетень "Белая ромашка"', path: '' }]} />
            <div className={styles.bulletins_content}>
                {bulletins.results?.map(bulletin => {
                    return (
                        <a href={bulletin.file} target="_blank" rel="noreferrer">
                            <div className={styles.bulletin_single}>
                                <h1>{bulletin.about}</h1>
                                <div className={styles.bulletin_info}>
                                    №{bulletin.number} &nbsp;&nbsp;
                                    <FiCalendar />
                                    <Moment format="MM, YYYY">
                                        {bulletin.date}
                                    </Moment>
                                </div>
                            </div>
                        </a>
                    )
                })}
            </div>
        </>
    );
}

export default Bulletins
